/** Expand a drawn control to a 44px touch target without changing its visible box. */
export const hitTarget44 = {
  from24: "relative after:absolute after:-inset-2.5 after:content-['']",
  from32: "relative after:absolute after:-inset-1.5 after:content-['']",
  from40: "relative after:absolute after:-inset-0.5 after:content-['']",
} as const;
